import { ComponentProps, useMemo } from 'react';
import { useIntl } from 'react-intl';
import useAlgoliaConfigs from '@alltrails/context/hooks/useAlgoliaConfigs';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import useNaturalLanguageSearchExperiment from '@alltrails/layout/hooks/useNaturalLanguageSearchExperiment';
import AlgoliaSearchBox from '@alltrails/search/components/AlgoliaSearchBox';
import getNaturalLanguageSearchUrl from '@alltrails/search/utils/getNaturalLanguageSearchUrl';
import HomeHeroCtas from '../HomeHeader/HomeHeroCtas';
import styles from './styles.module.scss';

const HomeSearchBar = () => {
  const intl = useIntl();
  const algoliaConfigs = useAlgoliaConfigs();
  const languageRegionCode = useLanguageRegionCode();

  const isTripPlannerV2Enabled = useExperiments()['web-disco-rm-trip-planner-v2']?.value === 'on';
  const { isNaturalLanguageSearchEnabled, onInputFocus } = useNaturalLanguageSearchExperiment();
  const handleNaturalLanguageResultSelect = useMemo<ComponentProps<typeof AlgoliaSearchBox>['onNaturalLanguageResultSelect']>(() => {
    if (!isNaturalLanguageSearchEnabled) {
      return undefined;
    }
    return (query, clickPosition, selectionType, selectionMethod) => {
      const url = getNaturalLanguageSearchUrl({ query, clickPosition, languageRegionCode, selectionType, selectionMethod, searchOrigin: 'homepage' });
      window.location.assign(url);
    };
  }, [languageRegionCode, isNaturalLanguageSearchEnabled]);

  const placeholder = isNaturalLanguageSearchEnabled
    ? intl.formatMessage({ defaultMessage: 'Search for anything' })
    : intl.formatMessage({ defaultMessage: 'Search by city, park, or trail name' });

  return (
    <div className={styles.container}>
      <AlgoliaSearchBox
        className={styles.search}
        configs={algoliaConfigs}
        emptyQueryContent={isTripPlannerV2Enabled ? <HomeHeroCtas className={styles.dropdownCtas} hideNearbyTrails variant="secondary" /> : undefined}
        navigateOnSelect
        onInputFocus={onInputFocus}
        onNaturalLanguageResultSelect={handleNaturalLanguageResultSelect}
        placeholder={placeholder}
        searchOrigin="homepage"
        searchTypes="all"
        showTrendingSuggestions
        size="homepage"
        useTypeAhead
      />
    </div>
  );
};

export default HomeSearchBar;
